<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 class="p-mt-6 titulo-admin p-ml-2">Listado de Usuarios</h2>          
          <DataTable
            ref="dt"
            :value="usuarios"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} usuarios"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                   name="nuevo"
                />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="identificacion" header="Ident." :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Ident.</span>
                {{ slotProps.data.identificacion }}
              </template>
            </Column>
            <Column field="nombres" header="Nombres" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombres</span>
                {{ slotProps.data.nombres }}
              </template>
            </Column>
            <Column field="apellidos" header="Apellidos" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Apellidos</span>
                {{ slotProps.data.apellidos }}
              </template>
            </Column>
            <Column field="tipo_usuario" header="T. Usuario" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">T. Usuario</span>
                {{ slotProps.data.tipo_usuario }}
              </template>
            </Column>
            <Column field="email" header="Email" :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Email</span>
                <span class="muyLargo">{{ slotProps.data.email }}</span>
              </template></Column
            >
            <Column field="telefono" header="Teléfono" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Teléfono</span>
                <span class="muyLargo">{{ slotProps.data.telefono }}</span>
              </template>
            </Column>
            <Column field="ocultar_en_especialistas" header="Oculto" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Oculto</span>
                <span class="muyLargo">{{ slotProps.data.ocultar_en_especialistas?'Si':'No' }}</span>
              </template>
            </Column>
            <Column field="username" header="Usuario" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Usuario</span>
                <span class="muyLargo">{{ slotProps.data.username }}</span>
              </template>
            </Column>
            <Column field="avatar" header="Avatar" :sortable="true">
              <template #body="slotProps" style="text-align:center">
                <span class="p-column-title">Avatar</span>
                <img
                  :src="urlAvatar + slotProps.data.avatar"
                  alt=""
                  v-if="slotProps.data.avatar != ''"
                  height="50px"
                  style="border-radius:10000px"
                />
                <img
                  :src="urlAvatar + 'hombre-avatar-oscuro_74s51$.jpg'"
                  alt=""
                  v-else
                  height="50px"
                  style="border-radius:10000px"
                />
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editUsuario(slotProps.data)"
                  v-tooltip.top="'Editar'"
                   name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning p-mr-2"
                  @click="confirmDeleteUsuario(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                   name="eliminar"
                />
                <Button icon="pi pi-eye" class="p-button-rounded p-button-warning p-mr-2"
                  @click="toggleEnListado(slotProps.data, 0)" v-tooltip.top="'Mostrar en especialistas'" name="mostrar"
                  v-if="slotProps.data.ocultar_en_especialistas && slotProps.data.tipo_usuario == 'user'" />
                <Button icon="pi pi-eye-slash" class="p-button-rounded p-button-warning p-mr-2"
                  @click="toggleEnListado(slotProps.data, 1)" v-tooltip.top="'Ocultar en especialistas'" name="ocultar"
                  v-if="!slotProps.data.ocultar_en_especialistas && slotProps.data.tipo_usuario == 'user'" />
                <Button
                  icon="mdi mdi-seal"
                  class="p-button-rounded p-button-info"
                  @click="administrarEspecialidades(slotProps.data)"
                  v-if="slotProps.data.tipo_usuario == 'user'"
                  v-tooltip.top="'Especializaciones del usuario'"
                   name="especialidades"
                />
              </template>
            </Column>
          </DataTable>

          <Dialog
            :closable="false"
            :visible="usuarioDialog"
            :style="{ width: '450px' }"
            header="Detalles del Usuario"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-6 p-md-6">
                <label for="identificacion">Identificación</label>
                <InputText
                  id="identificacion"
                  v-model.trim="usuario.identificacion"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.identificacion }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuario.identificacion"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="nombres">Nombres</label>
                <InputText
                  id="nombres"
                  v-model.trim="usuario.nombres"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.nombres }"
                />
                <small class="p-invalid" v-if="submitted && !usuario.nombres"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="apellidos">Apellidos</label>
                <InputText
                  id="apellidos"
                  v-model.trim="usuario.apellidos"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.apellidos }"
                />
                <small class="p-invalid" v-if="submitted && !usuario.apellidos"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="tipo_usuario">Tipo de Usuario</label>
                <Dropdown
                  id="tipo_usuario"
                  v-model="usuario.tipo_usuario"
                  :options="tiposDeUsuario"
                  placeholder="Tipo de usuario"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.tipo_usuario }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuario.tipo_usuario"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="email">Email</label>
                <InputText
                  id="email"
                  v-model.trim="usuario.email"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.email }"
                />
                <small class="p-invalid" v-if="submitted && !usuario.email"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="telefono">Teléfono</label>
                <InputText
                  id="telefono"
                  v-model.trim="usuario.telefono"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.telefono }"
                />
                <small class="p-invalid" v-if="submitted && !usuario.telefono"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="username">Usuario</label>
                <InputText
                  id="username"
                  v-model.trim="usuario.username"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !usuario.username }"
                  :disabled="this.usuario.id"
                />
                <small class="p-invalid" v-if="submitted && !usuario.username"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="nombre_asistente">Nombre Asistente</label>
                <InputText
                  id="nombre_asistente"
                  v-model.trim="usuario.nombre_asistente"                  
                  autofocus
                />                
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="telefono_consultorio">Teléfono Consultorio</label>
                <InputText
                  id="telefono_consultorio"
                  v-model.trim="usuario.telefono_consultorio"                  
                  autofocus
                />                
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="direccion_consultorio">Dirección Consultorio</label>
                <InputText
                  id="direccion_consultorio"
                  v-model.trim="usuario.direccion_consultorio"                  
                  autofocus
                />                
              </div>
              <div class="p-field p-col-6 p-md-6">
                <label for="observaciones">Observaciones</label>
                <InputText
                  id="observaciones"
                  v-model.trim="usuario.observaciones"                  
                  autofocus
                />                
              </div>
              <div class="p-field p-col-12 p-md-12">
                <Button
                  icon="pi pi-times"
                   name="noavatar"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="eliminarAvatar"
                  v-if="
                    this.usuario.id &&
                      this.usuario.avatar != '' &&
                      !avatarFueTocado
                  "
                />
                <label for="avatar" class="custom-file-upload">Avatar</label>
                <input
                  type="file"
                  id="avatar"
                  accept="image/*"
                  @change="onUpload($event)"
                />
                <span class="p-ml-3">{{ nombreFile }}</span>
                <span
                  v-if="sizeFile > 0"
                  style="font-size: 9px;font-weight: 700;margin-left: 5px;"
                  >{{ sizeFile.toFixed(2) }}Kb</span
                >
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                :disabled="loading"
                 name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveusuario"
                :disabled="loading"
                 name="guardar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteUsuarioDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="usuario"
                >Esta seguro que desea eliminar el usuario
                <b>{{ usuario.nombres }} {{ usuario.apellidos }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteUsuarioDialog = false"
                 name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteUsuario"
                 name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuariosService from "../service/usuarios.service";
import { mapMutations } from "vuex";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      usuariosService: null,
      filters: {},
      usuario: {},
      usuarios: [],
      usuarioDialog: false,
      tiposDeUsuario: ["admin", "user", "superadmin"],
      nombreFile: "",
      sizeFile: 0,
      typeFile: "",
      file: null, //desde aqui
      descripcion: "",
      fecha: null,
      hora: null,
      minDate: null,
      es: {
        firstDayOfWeek: 1,
        dayNames: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        clear: "Borrar",
        weekHeader: "Sm",
      },
      deleteUsuarioDialog: false,
      deleteProductsDialog: false,
      selectedProducts: null,
      submitted: false,
      loading: false,
      urlAvatar: "",
      avatarFueTocado: false,
    };
  },
  created() {
    this.usuariosService = new UsuariosService();
  },
  mounted() {
    this.urlAvatar = process.env.VUE_APP_API_AVATAR;
    this.recuperarUsuarios();
  },
  methods: {
    ...mapMutations(["setUsuario"]),
    recuperarUsuarios() {
      this.loading=true      
      this.usuariosService
        .allUsuarios()
        .then((result) => {
          if (result.data.data) {
            this.usuarios = [...result.data.data];
          }          
          this.loading=false
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error al cargar los usuarios",
                life: 3000,
              });
          this.loading=false
        });
    },
    toggleEnListado(usuario, ocultar_en_especialistas) {
      this.loading = true;
      this.usuariosService
        .toggleEnListado({ id: usuario.id, ocultar_en_especialistas })
        .then(() => {
          usuario.ocultar_en_especialistas = ocultar_en_especialistas;
          this.$set(
            this.usuarios,
            this.findIndexById(usuario.id),
            usuario
          );
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: `usuario ${ocultar_en_especialistas ? "mostrado" : "ocultado"
              } en listado de especialistas`,
            life: 3000,
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error al ${ocultar_en_especialistas ? "mostrar" : "ocultar"
              } el usuario en listado de especialistas`,
            life: 3000,
          });
          this.loading = false;
        });
    },
    onUpload(event) {
      this.avatarFueTocado = true;
      this.nombreFile =
        event.target.files.length == 0 ? "" : event.target.files[0].name;
      this.sizeFile =
        event.target.files.length == 0 ? 0 : event.target.files[0].size / 1024;
      this.typeFile =
        event.target.files.length == 0 ? "" : event.target.files[0].type;

      if (event.target.files.length == 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
      } else if (
        this.typeFile.indexOf("jpeg") == -1 &&
        this.typeFile.indexOf("png") == -1
      ) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar debe ser jpeg ó png",
          life: 3000,
        });
      } else if (this.sizeFile > 1024) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar no debe ser mayor a 1Mb",
          life: 3000,
        });
      } else if (this.sizeFile <= 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar debe ser jpg ó png no mayor a 1Mb",
          life: 3000,
        });
      } else {
        this.file = event.target.files[0];
      }
    },
    openNew() {
      this.usuario = {};
      this.file = null;
      this.nombreFile = "";
      this.sizeFile = 0;
      this.typeFile = "";
      this.submitted = false;
      this.usuarioDialog = true;
    },
    hideDialog() {
      this.usuarioDialog = false;
      this.submitted = false;
    },
    async saveusuario() {
      this.submitted = true;
      if (
        this.usuario.identificacion &&
        this.usuario.nombres &&
        this.usuario.apellidos &&
        this.usuario.tipo_usuario &&
        this.usuario.email &&
        this.usuario.telefono &&
        this.usuario.username
      ) {
        this.loading = true;
        if (this.usuario.id) {
          //edicion de usuario
          let idUsuarioEnEdicion = this.usuario.id;
          let usuarioEditado = {};
          await this.usuariosService
            .editarUsuario(this.usuario)
            .then((result) => {
              usuarioEditado = result.data.data;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });

          if (this.avatarFueTocado == true) {
            if (this.file != null) {
              let dataAvatar = new FormData();
              dataAvatar.append("avatar", this.file);
              dataAvatar.append(
                "datos",
                JSON.stringify({ id_usuario: idUsuarioEnEdicion })
              );
              await this.usuariosService
                .subirAvatar(dataAvatar)
                .then((result) => {
                  usuarioEditado = result.data.data;
                  this.loading = false;
                })
                .catch((err) => {
                  console.log(err);
                  this.loading = false;
                });
            } else {
              this.loading = false;
              let data = {
                id: idUsuarioEnEdicion,
              };
              await this.usuariosService.eliminarAvatar(data).catch((err) => {
                console.log(err);
              });
            }
          }
          this.$set(
            this.usuarios,
            this.findIndexById(idUsuarioEnEdicion),
            usuarioEditado
          );
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Usuario actualizado",
            life: 3000,
          });
          this.usuarioDialog = false;
          this.usuario = {};
        } else {
          //nuevo usuario
          this.usuario["avatar"] = "";
          let idNuevoUsuario = 0;
          let usuarioCreado = {};
          await this.usuariosService
            .crearUsuario(this.usuario)
            .then((result) => {
              if (!result.data.data) {
                this.$toast.add({
                  severity: "error",
                  summary: "Error al guardar",
                  detail: result.data.errores.join(" , "),
                  life: 3000,
                });
              } else {
                idNuevoUsuario = result.data.data.id;
                usuarioCreado = result.data.data;
                this.$toast.add({
                  severity: "success",
                  summary: "Felicidades",
                  detail: "Usuario creado",
                  life: 3000,
                });                
              }
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });            

          if (this.file != null && idNuevoUsuario > 0) {
            let dataAvatar = new FormData();
            dataAvatar.append("avatar", this.file);
            dataAvatar.append(
              "datos",
              JSON.stringify({ id_usuario: idNuevoUsuario })
            );
            await this.usuariosService
              .subirAvatar(dataAvatar)
              .then((result) => {
                if (!result.data.data) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error al guardar el Avatar",
                    detail: result.data.errores.join(" , "),
                    life: 3000,
                  });
                } else {
                  usuarioCreado = result.data.data;                  
                }
                this.loading = false;
              })
              .catch((err) => {
                this.loading = false;
                console.log(err);
              });
          }
          this.loading = false;
          if(idNuevoUsuario>0){            
            this.usuarios.push(usuarioCreado);
            this.usuarioDialog = false;
            this.usuario = {};
          }          
        }        
      }
    },
    editUsuario(usuario) {
      this.usuario = { ...usuario };
      this.nombreFile = usuario.avatar;
      this.sizeFile = 0;
      this.typeFile = "";
      this.usuarioDialog = true;
    },
    eliminarAvatar() {
      this.usuariosService
        .eliminarAvatar({ id: this.usuario.id })
        .then(() => {
          this.usuario.avatar = "";
          this.$set(
            this.usuarios,
            this.findIndexById(this.usuario.id),
            this.usuario
          );
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Se eliminó el avatar del usuario",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.usuarios.length; i++) {
        if (this.usuarios[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteUsuario(usuario) {
      this.usuario = usuario;
      this.deleteUsuarioDialog = true;
    },
    deleteUsuario() {
      this.usuariosService
        .eliminarUsuario({ id: this.usuario.id })
        .then(() => {
          this.usuarios = this.usuarios.filter(
            (val) => val.id !== this.usuario.id
          );
          this.deleteUsuarioDialog = false;
          this.usuario = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Usuario eliminado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    administrarEspecialidades(usuario) {
      this.setUsuario(usuario);
      this.$router.push({ name: "usuario-especialidades" });
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
